import { render, staticRenderFns } from "./channelOut.vue?vue&type=template&id=16dd1227&scoped=true&"
import script from "./channelOut.vue?vue&type=script&lang=js&"
export * from "./channelOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd1227",
  null
  
)

export default component.exports